/**
 * Hobien CRM
 * Copyright 2020 All Rights Reserved
 * Created By d.chaow
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

const DEBUG = import.meta.env.DEV;

if (!DEBUG) {
  Sentry.init({
    dsn: 'https://719963e2780be19ee2f747fb6e9582cd@o4508362196123648.ingest.us.sentry.io/4508362202611712',
    integrations: [],
  });
}

// Save a reference to the root element for reuse
const rootEl = document.getElementById('root');

// Create a reusable render method that we can call more than once
let render = () => {
  // Dynamically import our main App component, and render it
  // const MainApp = require('./App').default;
  // ReactDOM.render(<MainApp />, rootEl);
  const root = createRoot(rootEl);
  root.render(<App />);
};

render();
